import { BaseModel } from "../base.model";
import { MyfileListModel } from "../myfile/myfile-list.model";
import { MyfileModel } from "../myfile/myfile.model";
import { RequisitionModel } from "./requisition.model";

export class RequisitionViewDataModel extends BaseModel {
    requisition?: RequisitionModel;
    myfile?: MyfileModel;  
    myfileList: MyfileListModel = new MyfileListModel();
}
